import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerConservazioneGeneratePackageModalComponent } from './worker-conservazione-generate-package-modal';

export const WorkerConservazioneGeneratePackageModalModule: string = ng
    .module('worker-conservazione-generate-package-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerConservazioneGeneratePackageModalComponent', WorkerConservazioneGeneratePackageModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-conservazione-generate-package-modal/worker-conservazione-generate-package-modal.module.ts